import { constants } from '../config';

const CART_ITEM_STATES = {
  NO_ISSUES: 0,
  PRICE_CHANGED: 1,
  MAX_AMOUNT_CHANGED: 2,
  PRODUCT_STATE_CHANGED: 3,
  NO_STOCK: 4,
};

const getDebitCartTax = cart =>
  cart && cart.find(item => item.product.id === constants.productIdCreditCardTax);

const unIncludeDebitCartTax = cart =>
  (cart ? cart.filter(item => item.product.id !== constants.productIdCreditCardTax) : []);

const calculateCartItemAmount = cart =>
  unIncludeDebitCartTax(cart).reduce((prev, cur) => prev + cur.amount, 0);

export { CART_ITEM_STATES, calculateCartItemAmount, unIncludeDebitCartTax, getDebitCartTax };



// WEBPACK FOOTER //
// ./src/helpers/CartHelper.js